var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{ref:"section",staticClass:"partners-view-section-content-list-item"},[_c('div',{staticClass:"partners-view-section-content-list-item-dot"}),_c('span',{class:{
      'text-body2': _vm.$mq === 'xl' || _vm.$mq === 'l',
      'text-body4': _vm.$mq === 'm',
      'text-body6': _vm.$mq === 's'
    },domProps:{"innerHTML":_vm._s(_vm.item.fullName)},on:{"click":function($event){return _vm.selectHandler(_vm.sectionName, _vm.item.name)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }